import { Link, Typography, TypographyProps } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useUserContext } from 'src/auth/useUserContext';
import { PATH_DASHBOARD } from 'src/routes/paths';

type OrganizationLinkProps = {
  name?: string;
  slug?: string;
  id?: string;
  color?: TypographyProps['color'];
  variant?: TypographyProps['variant'];
};

export default function OrganizationLink({
  name,
  slug,
  id,
  color = 'text.primary',
  variant = 'body1',
}: OrganizationLinkProps) {
  const { isUserRole } = useUserContext();

  if (isUserRole) {
    return (
      <Link
        component={RouterLink}
        to={`${PATH_DASHBOARD.general.search.organization(
          slug || id || '',
        )}?type=all`}
        color={color}
        underline="always"
        variant={variant}
      >
        {name}
      </Link>
    );
  }

  return (
    <Typography color={color} variant={variant}>
      {name}
    </Typography>
  );
}
